import { z } from "zod/v4";

export const ThirdPartyEnvObject = {
    googleFontsApiKey: process.env.VITE_GOOGLE_FONT_API,
    pusherAppKey: process.env.VITE_PUSHER_APP_KEY,
    pusherAppCluster: process.env.VITE_PUSHER_APP_CLUSTER,
} as const;

export const ThirdPartyConfigSchema = z.object({
    googleFontsApiKey: z.string(),
    pusherAppKey: z.string().optional(),
    pusherAppCluster: z.string().optional(),
});

export type TThirdPartyConfig = z.infer<typeof ThirdPartyConfigSchema>;
